document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("LoadMoreButton");
  const grid = document.getElementById("product-grid");

  if (!btn || !grid) return;

 const getNextUrlFromDoc = (doc) => {
  // 1) Si la página siguiente también tiene el mismo botón, lee su data-next-url
  const nextBtn = doc.querySelector("#LoadMoreButton");
  if (nextBtn && nextBtn.dataset.nextUrl) return nextBtn.dataset.nextUrl;

  // 2) Fallbacks por si existiera paginación en algún tema
  const nextA =
    doc.querySelector(".pagination__item--next a") ||
    doc.querySelector("a[rel='next']");

  return nextA ? nextA.getAttribute("href") : null;
};


  btn.addEventListener("click", async () => {
    const nextUrl = btn.dataset.nextUrl;

    if (!nextUrl) {
      // No hay siguiente página => ya no hay más productos
      btn.style.display = "none";
      return;
    }

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Cargando...";

    try {
      const res = await fetch(nextUrl, { credentials: "same-origin" });
      if (!res.ok) throw new Error("No se pudo cargar la siguiente página.");

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newItems = doc.querySelectorAll("#product-grid > li");
      newItems.forEach((li) => grid.appendChild(li));

      // Actualiza nextUrl para el siguiente click
      const newNextUrl = getNextUrlFromDoc(doc);
      btn.dataset.nextUrl = newNextUrl || "";

      // Si ya no hay next => ocultamos el botón
      if (!newNextUrl) btn.style.display = "none";
    } catch (e) {
      console.error(e);
      // Si falla, re-habilita el botón para reintentar
      btn.disabled = false;
      btn.textContent = originalText;
      return;
    }

    btn.disabled = false;
    btn.textContent = originalText;
  });
});
